import { Injectable } from '@angular/core';
import { apiUrl } from '../schema/api-url';
import { APIService } from './master/api.service';
import { BaseService } from './master/base.service';

/**
 * @author ToiTV
 * 2021-09-20
 */

@Injectable({
    providedIn: 'root'
})
export class SysTemConfigService extends BaseService {

    public DATA : any[] = []; 

    constructor(private _apiService: APIService) {
        super(_apiService);
    }

    /**
     * Get system config
     */
    async getSystemConfig(code, unit, subSystem) {
        try {
            var data = await super.get(apiUrl.danhMuc.systemConfig, {
                code: code,
                unit: unit,
                subSystem: subSystem
            }).toPromise();
            if (data) {
                this.DATA = data;
                localStorage.setItem("SYSTEM_CONFIG", JSON.stringify(data));
            }
        } catch (error) {
            
        }
    }

    public getConfig(key: string, def: any) {
        var data = localStorage.getItem("SYSTEM_CONFIG");
        if (data) {
            var value = JSON.parse(data).filter(p => p.Code == key);
            return value.length > 0 ? value[0].Value : def;
        } else {
            return def;
        }
    }
}
